import {Loading} from 'element-ui'
import router from '../router'
export default {
  loading: (text = 'processing...') => {
    return Loading.service({
      lock: true,
      text: text,
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  },
  reset: (formRef, ...excludeFields) => {
    this.$refs[formRef].resetFields();
    let obj1 = this.$data;
    let obj2 = this.$options.data.call(this);

    if (!excludeFields || excludeFields.length === 0) {
      excludeFields = ["rules"];
    }
    for (let attrName in obj1) {
      if (excludeFields && excludeFields.includes(attrName)) {
        continue;
      }
      obj1[attrName] = obj2[attrName];
    }
  },
  saveToken: (tokenJsonStr) => {
    sessionStorage.setItem('admin_access_token', tokenJsonStr);
  },
  getToken: () => {
    const tokenJsonStr = sessionStorage.getItem('admin_access_token');
    return tokenJsonStr;
  },
  removeToken: () => {
    sessionStorage.removeItem('admin_access_token');
  },
  saveRole: (role) => {
    sessionStorage.setItem('admin_user_role', role);
  },
  getRole: () => {
    const role = sessionStorage.getItem('admin_user_role');
    return role;
  },
  removeRole: () => {
    sessionStorage.removeItem('admin_user_role');
  },
  gotoLogin() {
    this.removeToken();
    this.removeRole();
    this.delete('menus');
    this.delete('user_email');
    router.push({path:"/login"});
  },
  clearObject(object) {    //清除一个对象所有值
    for (let key in object) {
        object[key] = '';
    }
  },
  fetch(name) {
    //return JSON.parse(window.localStorage.getItem(name) || null);
    return JSON.parse(window.sessionStorage.getItem(name) || null);
  },
  save(name,items) {
    //window.localStorage.setItem(name, JSON.stringify(items));
    window.sessionStorage.setItem(name, JSON.stringify(items));
  },
  delete(name){
    //window.localStorage.removeItem(name);
    window.sessionStorage.removeItem(name);
  }
}



// WEBPACK FOOTER //
// ./src/util/util.js